const taskTypeEnum = {
    ORDER: 1,
    SELF_PURCHASE: 2,
    LIVING_AREA_RECIPE: 3,
    DOCTOR_OFFICE_RECIPE: 4
}

export default taskTypeEnum;